export default __webpack_public_path__ + "locales/en/WebPlugins.json?hash=bbed0706f3c1445f9fc290c1700558f7";